/**
 * OnboardingSuggestionBubbles
 * Two clickable suggestion chips rendered below the AI greeting
 * during onboarding. Each bubble sends its text as a user message
 * via sendMessage when clicked.
 *
 * Visibility: hidden when the user has explicitly clicked a bubble
 * (sent either "I'm looking for a practice" or "I want to share &
 * guide others"). Free-text input does NOT hide them.
 *
 * Figma: node-id=11985-39737
 */

interface SuggestionBubblesProps {
  onSelect: (text: string) => void
  disabled: boolean
}

const BUBBLE_BASE =
  "h-[50px] px-5 py-[15px] rounded-[100px] border font-semibold text-[13px] leading-5 text-left transition-opacity disabled:opacity-50" as const

export function OnboardingSuggestionBubbles({ onSelect, disabled }: SuggestionBubblesProps) {
  return (
    <div className="flex flex-col gap-2.5 justify-start items-start">
      <button
        type="button"
        onClick={() => onSelect("I'm looking for a practice")}
        disabled={disabled}
        className={`${BUBBLE_BASE} bg-[rgba(242,240,235,0.10)] border-[rgba(242,240,235,0.20)] text-[#F2F0EB] hover:bg-[rgba(242,240,235,0.15)]`}
      >
        I&apos;m looking for a practice
      </button>
      <button
        type="button"
        onClick={() => onSelect("I want to share & guide others")}
        disabled={disabled}
        className={`${BUBBLE_BASE} bg-[rgba(242,240,235,0.10)] border-[rgba(242,240,235,0.20)] text-[#F2F0EB] hover:bg-[rgba(242,240,235,0.15)]`}
      >
        I want to share &amp; guide others
      </button>
    </div>
  )
}
